import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const AddCompanyModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.businessGroupSection': {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '5px',

    '.subTitle': {
      fontWeight: 'bold',
    },

    '.cellSection': {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
    }
  },

  '.companiesSection': {
    display: 'flex',
    flexDirection: 'column',

    '.subTitle': {
      display: 'flex',
      fontWeight: 'bold',
      flexDirection: 'row',
      justifyContent: 'space-between',

      '.leftPanel': {
        display: 'flex',
      },

      '.counting': {
        marginLeft: '5px',
      },

      '.counting.blue': {
        color: v.ezBlue,
      },

      '.counting.red': {
        color: v.ezRedColor
      },

      '.clearButton': {
        marginRight: '8px',
        color: v.ezRedColor,
        textDecoration: 'underline',
        cursor: 'pointer',
      }
    },

    '.cellSection': {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
    }
  },

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const CompanyCellContainer = styled.div({
  display: 'flex',
  marginTop: '5px',
  padding: '8px',
  borderRadius: '5px',
  border: 'solid 1px #999',
  alignItems: 'center',
  cursor: 'pointer',
  width: '49%',

  '&:nth-child(odd)': {
    marginRight: '10px'
  },

  input: {
    marginRight: '5px',
  },

  '&.disable': {
    border: 'solid 1px #CCC',
    color: '#CCC',
    cursor: 'default',
  },

  '&.selected': {
    border: `solid 1px ${v.ezMainColor}`,
  }
})

export const BusinessGroupCellContainer = styled.div({
  display: 'flex',
  marginTop: '5px',
  padding: '8px',
  borderRadius: '5px',
  border: 'solid 1px #999',
  alignItems: 'center',
  cursor: 'pointer',
  width: '24%',
  marginRight: '4px',
  marginLeft: '4px',

  '&:hover': {
    boxShadow:'0 4px 4px 0 rgba(0, 0, 0, 0.1)',
    fontWeight: 'bold'
  }
})
